export const GET_HEADER =  "https://unified-masthead-ci.r1.pcf.dell.com/csbapi/masthead/masthead/us/en/dhs/19/Stp?version=2&nod=0&loader=true";
export const GET_FOOTER =  "https://www.dell.com/csbapi/masthead/unifiedfooter/stp/";
export const GET_FOOTER_TAIL = "?onlyfooter=true&birdseed=false&readonlycountryselector=true";
export const GET_CAPTCHA = "api/captcha";
export const GET_REFRESH_CAPTCHA = "api/refreshcaptcha";
export const GET_VALIDATE_SIGNUP = "api/SaveSignUpDetail";
export const GET_CONTENT_DATA = "api/getcontentData";
export const GET_MATCHED_LANGUAGE_DATA = "api/getMatchedLanguage";
export const GET_CAPTCHA_AUDIO = "api/captchaAudio";
export const TOKEN_URL = 'https://www-sit-g4.dell.com/di/api/v3/oauth/token';

//export const GET_CAPTCHA = "https://localhost:7058/api/captcha";
//export const GET_REFRESH_CAPTCHA = "https://localhost:7058/api/refreshcaptcha";
//export const GET_VALIDATE_SIGNUP = "https://localhost:7058/api/SaveSignUpDetail";
//export const GET_CONTENT_DATA = "https://localhost:7058/api/getcontentData";
//export const GET_MATCHED_LANGUAGE_DATA = "https://localhost:7058/api/getMatchedLanguage";
//export const GET_CAPTCHA_AUDIO = "https://localhost:7058/api/captchaAudio";

export const WEBSOURCESID = "777016";
export const MFEAPIURL = window.__APP_CONFIG__?.mfeApiUrl ?? "https://www.dell.com/preferences/ncm/api/loader";